import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useMakeMeAdmin } from '@/hooks/use-make-me-admin';
import { Shield, Loader2, Check } from 'lucide-react';

export function MakeMeAdminButton(): React.ReactElement {
  const { makeAdmin, isLoading, result } = useMakeMeAdmin();
  const [showSuccess, setShowSuccess] = useState(false);

  const handleClick = async (): Promise<void> => {
    const response = await makeAdmin();
    if (response.success) {
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
    }
  };

  const isSuccess = showSuccess && result?.success;

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleClick}
      disabled={isLoading}
      className="gap-2"
      title="Add yourself to the Administrators team with all permissions"
    >
      {isLoading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : isSuccess ? (
        <Check className="h-4 w-4 text-green-500" />
      ) : (
        <Shield className="h-4 w-4" />
      )}
      <span className="hidden sm:inline">
        {isLoading ? 'Adding...' : isSuccess ? 'Admin!' : 'Make Me Admin'}
      </span>
    </Button>
  );
}
